import { forwardRef, type ReactNode } from 'react'
import { Collapsible as BaseCollapsible } from '@base-ui/react/collapsible'
import { ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import './collapsible.css'

export type CollapsibleProps = {
  /** The trigger’s content, for example a name and a count. It names the button, so keep it short. */
  trigger: ReactNode
  /** The content revealed when open. */
  children: ReactNode
  /** Whether the panel is open, when controlled. */
  open?: boolean
  /** Whether the panel starts open, when uncontrolled. */
  defaultOpen?: boolean
  onOpenChange?: (open: boolean) => void
  disabled?: boolean
  /** Keep the closed panel in the DOM, for example to preserve form input. */
  keepMounted?: boolean
  className?: string
}

/** Shows and hides one section of related content behind a labelled button, such as an organization’s streams. */
export const Collapsible = forwardRef<HTMLDivElement, CollapsibleProps>(function Collapsible(
  { trigger, children, open, defaultOpen, onOpenChange, disabled, keepMounted, className },
  ref,
) {
  return (
    <BaseCollapsible.Root
      ref={ref}
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={(next) => onOpenChange?.(next)}
      disabled={disabled}
      className={cn('play-collapsible', className)}
    >
      <BaseCollapsible.Trigger className="play-collapsible__trigger">
        <ChevronRight className="play-collapsible__indicator" aria-hidden="true" />
        {trigger}
      </BaseCollapsible.Trigger>
      <BaseCollapsible.Panel keepMounted={keepMounted} className="play-collapsible__panel">
        <div className="play-collapsible__content">{children}</div>
      </BaseCollapsible.Panel>
    </BaseCollapsible.Root>
  )
})
